import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in St. Joseph, MO?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a St. Joseph post office can take 2–6 months. The nearest regional passport agency is the Chicago Passport Agency at 230 S Dearborn St, Suite 380, Chicago, IL 60604 — about 500 miles northeast. Appointments there require documented life-or-death emergencies. For Northwest Missouri agriculture professionals, MWSU students, and I-29 corridor business travelers, expedited processing through a registered courier is the predictable option.",
  },
  {
    q: "Do I need to go to the Chicago Passport Agency for my passport?",
    a: "No — Fast Passport Center is your alternative. The Chicago Passport Agency at 230 S Dearborn St, Suite 380, Chicago, IL 60604 is approximately 500 miles northeast — an 8-hour drive from St. Joseph. Appointments there are for documented life-or-death emergencies only. We provide reserved courier submission: start online, ship documents overnight from the St. Joseph UPS or FedEx, and receive your passport within the timeframe you select. No appointment race, no 8-hour drive to Chicago.",
  },
  {
    q: "Can MWSU students get a passport fast for study abroad?",
    a: "Yes. Missouri Western State University students who receive study-abroad program acceptance often need expedited service quickly. Many MWSU students are first-time applicants — they need to visit an acceptance clerk at a St. Joseph post office first. We guide you through the exact location, forms, and timeline so you don't miss your program orientation. Expedited processing is available after the clerk visit.",
  },
  {
    q: "What about agriculture industry travel to Canada and Mexico?",
    a: "Agriculture-related passport urgency is one of the most common situations we handle for St. Joseph-area clients. Cattle buyers, grain export brokers, and livestock industry professionals often need to travel to Canada or Mexico on short notice when commodity market conditions require action. We regularly process expedited passports for Northwest Missouri agriculture professionals with 1–2 week departure windows.",
  },
  {
    q: "How quickly can Savannah or Kearney residents get an expedited passport?",
    a: "Savannah, Kearney, Smithville, Platte City, and all Buchanan and Andrew County communities are fully within our service area. Your location in Northwest Missouri does not affect processing speed — start online, ship overnight from any carrier location near you, and we handle the rest. Most St. Joseph metro area residents receive passports within 2–9 business days depending on the option selected.",
  },
  {
    q: "What is the nearest Regional Passport Agency to St. Joseph?",
    a: "The nearest Regional Passport Agency to St. Joseph is the Chicago Passport Agency at 230 S Dearborn St, Suite 380, Chicago, IL 60604 — approximately 500 miles northeast. For true life-or-death emergencies (documented bereavement or medical crisis), they serve walk-in appointments. For non-emergency expedited processing, Fast Passport Center's reserved courier submission is the predictable alternative that doesn't require a 16-hour round trip.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function StJosephFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything St. Joseph and Northwest Missouri travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden">
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`text-white text-sm transition-transform duration-200 ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}